var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import OperationLogService from '../../api/OperationLogService';
import { Loading } from 'element-ui';
import ContentMore from '../../components/common/ContentMore.vue';
import DetailDialog from './DetailDialog.vue';
var RecordDialog = (function (_super) {
    __extends(RecordDialog, _super);
    function RecordDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 500;
        _this.row = null;
        _this.formData = {
            s_time: new Date((new Date().getTime() / 1000 - 6 * 86400) * 1000).format("yyyy-MM-dd"),
            e_time: new Date().format("yyyy-MM-dd"),
            account_id: '',
            operation_type: '',
            keyword: '',
        };
        _this.accountList = [];
        _this.operationType = [];
        _this.noMoreSup = false;
        _this.pageData = {
            page: 1,
            limit: 100,
        };
        return _this;
    }
    RecordDialog.prototype.created = function () {
        this.service = OperationLogService.getInstance();
        this.getAccountList();
        this.getOperationType();
        this.getLists();
    };
    RecordDialog.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.$el && _this.$el.parentElement) {
                _this.tableHeight = _this.$el.parentElement.clientHeight - 120;
            }
        }, 300);
    };
    RecordDialog.prototype.getAccountList = function (isMore) {
        var _this = this;
        if (isMore === void 0) { isMore = false; }
        this.service.getAccountList(Object.assign({
            keyword: this.formData.keyword
        }, this.pageData)).then(function (res) {
            if (!isMore) {
                _this.accountList = Array.isArray(res.data.data) ? res.data.data : [];
                _this.accountList.unshift({ 'account_id': -1, 'account_name': '全部' });
            }
            else {
                _this.accountList = _this.accountList.concat(Array.isArray(res.data.data) ? res.data.data : []);
                if (res.data.total <= _this.accountList.length) {
                    _this.noMoreSup = true;
                }
            }
        });
    };
    RecordDialog.prototype.getOperationType = function () {
        var _this = this;
        this.service.getOperationType().then(function (res) {
            _this.operationType = Array.isArray(res.data.data) ? res.data.data : [];
        });
    };
    RecordDialog.prototype.getLists = function () {
        var _this = this;
        var pager = this.$refs.pagination.getPage();
        if ((new Date(this.formData.e_time).getTime() - new Date(this.formData.s_time).getTime()) > 30 * 24 * 60 * 60 * 1000) {
            this.$message.error('查询日期不能超过30天！');
            return;
        }
        var params = {};
        Object.assign(params, pager, this.formData);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.operationList(params).then(function (res) {
            loadingInstance.close();
            _this.listData = res.data.data;
            _this.total = res.data.total;
        }).catch(function (err) {
            _this.$message.error(err.message);
            loadingInstance.close();
        });
    };
    RecordDialog.prototype.search = function () {
        this.$refs.pagination.clear();
        this.getLists();
    };
    RecordDialog.prototype.pageChange = function (pager) {
        this.getLists(pager);
    };
    RecordDialog.prototype.reset = function () {
        this.formData = {
            s_time: new Date((new Date().getTime() / 1000 - 6 * 86400) * 1000).format("yyyy-MM-dd"),
            e_time: new Date().format("yyyy-MM-dd"),
            account_id: '',
            operation_type: '',
            keyword: '',
        };
    };
    RecordDialog.prototype.resetPageData = function () {
        this.pageData = {
            page: 1,
            limit: 100,
        };
        this.noMoreSup = false;
        this.accountList = [];
    };
    RecordDialog.prototype.loadMoreSup = function () {
        if (!this.noMoreSup) {
            this.pageData.page++;
            this.pageData.start = ((this.pageData.page - 1) * this.pageData.limit) + 1;
            this.getAccountList(true);
        }
    };
    RecordDialog.prototype.showMore = function (content) {
        var instance = this.$dialog(DetailDialog, {
            data: {
                content: content
            }
        }, {
            title: "接口详情",
            width: 600,
            height: 520
        }).instance;
    };
    RecordDialog = __decorate([
        Component({
            components: {
                ContentMore: ContentMore,
                DetailDialog: DetailDialog,
            }
        })
    ], RecordDialog);
    return RecordDialog;
}(Vue));
export default RecordDialog;
